import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { PageHero, SectionHeading } from "../components/SectionHeading";
import { CargoTypes } from "../components/Showcase";
import { CtaBand } from "../components/CtaBand";
import { Icon } from "../components/Icon";
import { IMAGES, SERVICES } from "../data/content";

const SERVICE_IMG = { "open-carrier": IMAGES.hero, "enclosed-carrier": IMAGES.enclosed, "door-to-door": IMAGES.doorToDoor, expedited: IMAGES.freight };

const ServiceBlock = ({ s, i }) => (
  <article id={s.id} className="scroll-mt-32 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center py-16 border-b border-slate-200 last:border-0" data-testid={`service-section-${s.id}`}>
    <div className={i % 2 ? "lg:order-2" : ""}>
      <div className="relative">
        <img src={SERVICE_IMG[s.id]} alt={s.title} className="w-full aspect-[16/10] object-cover" />
        <span className="absolute top-0 left-0 font-display font-black text-[#0B1017] bg-amber-500 px-4 py-2 text-xl">{String(i + 1).padStart(2, "0")}</span>
      </div>
    </div>
    <div>
      <span className="w-12 h-12 grid place-items-center border border-amber-500/40 text-brand-600"><Icon name={s.icon} className="w-6 h-6" /></span>
      <h2 className="mt-6 font-display font-black uppercase text-slate-900 text-4xl sm:text-5xl leading-none">{s.title}</h2>
      <p className="mt-5 text-slate-700 leading-relaxed text-base md:text-lg">{s.body}</p>
      <ul className="mt-7 grid sm:grid-cols-2 gap-3">
        {s.points.map((p) => <li key={p} className="flex items-start gap-2 text-sm text-slate-800"><Check className="w-4 h-4 text-orange-600 mt-0.5 shrink-0" />{p}</li>)}
      </ul>
      <Link to={{ pathname: "/", hash: "#quote" }} className="btn-amber mt-8" data-testid={`service-quote-${s.id}`}>Quote {s.title} <ArrowRight className="w-4 h-4" /></Link>
    </div>
  </article>
);

export default function Services() {
  return (
    <>
      <PageHero testid="services-hero" eyebrow="Services" title="Transport built around your vehicle" image={IMAGES.enclosed}
        sub="Open or enclosed, standard or expedited, delivered to your driveway or straight to your mechanic. Every shipment moves under our federal authority with fully insured carriers." />
      <section className="container-x py-6">{SERVICES.map((s, i) => <ServiceBlock key={s.id} s={s} i={i} />)}</section>
      <section className="py-20 md:py-28 bg-[#F7F8FA] border-t border-slate-200" data-testid="services-types">
        <div className="container-x">
          <SectionHeading eyebrow="Types handled" title="Cars, SUVs, pickups, motorcycles, RVs & general freight" className="mb-12" />
          <CargoTypes />
        </div>
      </section>
      <CtaBand />
    </>
  );
}
